import { Div } from "../../common/ui/widgets";
import styled from "styled-components";

export const FeatureToggleWrapper = styled(Div)`
  padding: ${(props) => props.theme.padding20};
  width: calc(90vw - 20%);
  height: auto;
  font-size: ${(props) => props.theme.font16};
  h1 {
    font-family: "Helvetica", "texgyreheros-bold", "Tahoma", "Geneva", "Arial",
      sans-serif;
    font-weight: ${(props) => props.theme.fontWeight600};
    font-stretch: expanded;
    line-height: 1.125em;
    margin: 0;
    padding: 0;
    font-size: ${(props) => props.theme.font16};
  }
  p {
    margin: ${(props) => props.theme.padding10} 0;
  }
  a {
    color: #336699 !important;
    margin: ${(props) => props.theme.padding5} 0;
    cursor:pointer;
  }
  h6 {
    font-size: ${(props) => props.theme.font14}
    font-weight: ${(props) => props.theme.fontWeight600};
  }
  ul {
    margin:0;
    padding:0;
    padding-top: ${(props) => props.theme.padding10} !important;
    height: ${(props) => props.theme.height60vh};
    overflow: scroll;
    overflow-y: scroll;
    overflow-x: hidden;
    div{
        padding:${(props) => props.theme.padding1};
        width: fit-content;
    }
  }
  li {
    list-style: none;
  }

  input {
    margin-right: ${(props) => props.theme.margin5};
  }

  label {
    font-size: ${(props) => props.theme.font16};
    font-weight: ${(props) => props.theme.fontWeight400};
  }
  button {
    padding: ${(props) => props.theme.padding10}  ${(props) => props.theme.padding15};
    float: right;
  }

  @media only screen and (max-width: 500px) {
    width: calc(90vw - 5%);
  }

  @media only screen and (min-width: 1024px) {
    width: calc(90vw - 44%);
  }
`;
